import React, { useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography } from '@mui/material';

const Fichaje = ({ setMostrarFichaje }) => {
  const [idLoginEmpleado, setIdLoginEmpleado] = useState('');
  const [contraseña, setContraseña] = useState('');
  const [tipo, setTipo] = useState('entrada');
  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'idLoginEmpleado') setIdLoginEmpleado(value);
    if (name === 'contraseña') setContraseña(value);
    if (name === 'tipo') setTipo(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/fichar`, {
        id_login_empleado: idLoginEmpleado,
        contraseña: contraseña,
        tipo: tipo,
      });

      setMensaje(response.data.message);

      // 🔁 Cerrar modal automáticamente después de 1 segundo
      setTimeout(() => {
        setMostrarFichaje(false);
      }, 1000);

    } catch (error) {
      setMensaje(`Error: ${error.response ? error.response.data.message : error.message}`);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={3}>
      <Typography variant="h5" gutterBottom>
        Fichar Empleado
      </Typography>

      <form onSubmit={handleSubmit} style={{ width: '300px' }} autoComplete="off">
  <TextField
    label="ID de Usuario"
    variant="outlined"
    fullWidth
    name="idLoginEmpleado"
    value={idLoginEmpleado}
    onChange={handleChange}
    margin="normal"
    autoComplete="off" // 👈 importante aquí también
  />
  <TextField
    label="Contraseña"
    variant="outlined"
    type="password"
    fullWidth
    name="contraseña"
    value={contraseña}
    onChange={handleChange}
    margin="normal"
    autoComplete="new-password" // 👈 evita sugerencias de contraseña
  />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ marginTop: 2 }}
        >
          Fichar
        </Button>
      </form>

      {mensaje && (
        <Typography variant="body2" color={mensaje.startsWith('Error') ? 'error' : 'success'} mt={2}>
          {mensaje}
        </Typography>
      )}
    </Box>
  );
};

export default Fichaje;
